import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import {firestorePlugin} from "vuefire";
import VueMeta from "vue-meta";
import SocialSharing from 'vue-social-sharing';

const serialize = doc => {
  // documentSnapshot.data() DOES NOT contain the `id` of the document. By
  // default, Vuefire adds it as a non enumerable property named id.
  // This allows to easily create copies when updating documents, as using
  // the spread operator won't copy it

  return Object.defineProperties(doc.data(), {
    id: {
      value: doc.id
    },
    path: {
      value: doc.ref.path
    },
    ref: {
      value: doc.ref
    }
  });
};
Vue.use(firestorePlugin, {serialize});
Vue.prototype.window = window;
Vue.use(BootstrapVue);
Vue.use(VueMeta);
Vue.use(SocialSharing);


new Vue({
  router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
  data: {
    user: null,
    tempUserData: {},
    next: false,
    userRef: null
  }
}).$mount("#app");
